var gold = "/static/df56b337c36e26c9.png";

export { gold as default };
//# sourceMappingURL=gold.png.js.map
